import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles((theme: any) => ({
    badge: {
        display: 'inline-block',
        padding: [2, 9],
        borderRadius: 12,
        fontSize: '11px',
        fontWeight: 600,
        whiteSpace: 'nowrap',
        color: '#fff',
        lineHeight: '16px',
    },
    mono: {
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: '12px',
        wordBreak: 'break-all',
    },
    muted: {
        color: theme.palette.text.secondary,
        fontSize: '12px',
    },
    thumbRow: {
        display: 'flex',
        gap: 6,
        justifyContent: 'center',
        alignItems: 'center',
    },
    thumb: {
        width: 52,
        height: 52,
        borderRadius: 6,
        border: `1px solid ${theme.palette.divider}`,
        overflow: 'hidden',
        cursor: 'zoom-in',
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        '& img': {
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            display: 'block',
        },
        '&:hover': {
            outline: `2px solid ${theme.palette.primary.main}`,
        },
    },
    thumbEmpty: {
        width: 52,
        height: 52,
        borderRadius: 6,
        border: `1px dashed ${theme.palette.divider}`,
        color: theme.palette.text.secondary,
        fontSize: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        lineHeight: 1.1,
        padding: 2,
    },
    thumbLabel: {
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        fontSize: 9,
        lineHeight: '12px',
        textAlign: 'center',
        background: 'rgba(0,0,0,0.55)',
        color: '#fff',
        fontWeight: 600,
        letterSpacing: 0.2,
    },
    colorDot: {
        display: 'inline-block',
        width: 12,
        height: 12,
        borderRadius: '50%',
        border: `1px solid ${theme.palette.divider}`,
        verticalAlign: 'middle',
        marginRight: 6,
    },
    detailsCell: {
        paddingTop: '0 !important',
        paddingBottom: '0 !important',
        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.025)',
    },
    infoRow: {
        display: 'flex',
        gap: 8,
        padding: [5, 0],
        borderBottom: `1px solid ${theme.palette.divider}`,
        fontSize: '13px',
        '&:last-child': {
            borderBottom: 0,
        },
    },
    infoLabel: {
        color: theme.palette.text.secondary,
        minWidth: 170,
        flexShrink: 0,
    },
    infoValue: {
        fontWeight: 500,
        wordBreak: 'break-word',
        minWidth: 0,
    },
    link: {
        color: theme.palette.primary.main,
        textDecoration: 'none',
        wordBreak: 'break-all',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    imageCard: {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 8,
        padding: 8,
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
        minWidth: 0,
        backgroundColor: theme.palette.background.paper,
    },
    imageCardPreview: {
        height: 180,
        borderRadius: 6,
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'zoom-in',
        border: 0,
        padding: 0,
        width: '100%',
        '& img': {
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
            display: 'block',
        },
    },
    imageCardEmpty: {
        height: 180,
        borderRadius: 6,
        border: `1px dashed ${theme.palette.divider}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.text.secondary,
        fontSize: 13,
    },
    imageCardTitle: {
        fontSize: 12,
        fontWeight: 700,
    },
    imageCardMeta: {
        fontSize: 11,
        color: theme.palette.text.secondary,
        wordBreak: 'break-all',
    },
    imageCardActions: {
        display: 'flex',
        gap: 4,
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    sectionTitle: {
        fontSize: 13,
        fontWeight: 700,
        margin: [0, 0, 8, 0],
        color: theme.palette.primary.main,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
    },
    pre: {
        margin: 0,
        padding: 12,
        fontSize: 12,
        overflow: 'auto',
        maxHeight: 420,
        backgroundColor: theme.palette.action.hover,
        borderRadius: 6,
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    },
}));
